import React from 'react';
import { SettingsOrganizationCard } from './SettingsOrganizationCard';

export const SettingsOrganizationSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <SettingsOrganizationCard />
    </div>
  );
};

export default SettingsOrganizationSection;
